import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";

import {Account} from "../classes/account";
import {AccountService} from "../services/account.service";
import {Validation} from "@app/shared/enums/validation.enum";

@Component({
  selector: "app-account-auto-complete",
  templateUrl: "./account-auto-complete.component.html",
  styleUrls: ["./account-auto-complete.component.css"]
})
export class AccountAutoCompleteComponent implements OnInit, OnChanges {

  Validation: typeof Validation = Validation;

  accountOptions: Account[];
  selectedAccount: Account = new Account();

  defaultProperties = ["accountNumber", "accountName"];

  @Input() accountId: number;
  @Input() account: Account;
  @Input() properties: string[];

  @Output() handler: EventEmitter<Account> = new EventEmitter();

  constructor(private changeDetectorRef: ChangeDetectorRef, private dataService: AccountService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (this.accountId) {
      this.dataService.searchAccountById(this.accountId).subscribe(account => {
        this.selectedAccount = account;
      });
    } else {
      this.selectedAccount = null;
    }
    if (this.account) {
      this.selectedAccount = new Account();
      Object.assign(this.selectedAccount, this.account);
    }
    if (!this.properties) {
      this.properties = this.defaultProperties;
    }
  }

  searchAccount(event) {
    this.dataService.searchAccount(event.query).subscribe(res => {
      this.accountOptions = res.list;
    });
  }

  onSelectAccount() {
    if (this.account) {
      Object.assign(this.account, this.selectedAccount);
      this.handler.emit(this.account);
    } else {
      console.warn("The input account is null, thus could not be set. Handler needs to take care of the selected account");
      this.handler.emit(this.selectedAccount);
    }
  }

  clearAccount() {
    this.selectedAccount = new Account();
  }
}
